/* eslint-disable no-undef */
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { makeStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import PostAddIcon from '@material-ui/icons/PostAdd';
import MessageTemplate from 'src/pages/equity/components/common/notifications/MessageTemplate';
import { isMobileView } from 'src/utils/util';
import { VISIBLE } from 'src/constants/appConstants';
import UnsavedChanges from 'src/pages/scheduleSurgery/components/surgery/notifications/UnsavedChanges';
import {
    MdiOptions,
    OrderDetailFooterBottomNavWrapper,
    TorqueQROverlay,
} from './OrderDetailFooter.styled';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import {
    setSendReportModalState,
    closeOrderSummaryModalState,
    showDeleteOrderAction,
    showHideSummaryModal,
    showHideRequestInvoice,
    setReportProcedureModalState,
    setOrderSummaryModalState,
    setOrderSummaryTabAction,
    getOrderSummaryData,
} from 'src/pages/orders/redux/actions';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import {
    MdiImageSource,
    OrderSummaryTabs,
} from 'src/constants/orderListConstants';
import {
    isMobileDevice,
    getDefaultCTAId,
    getReportUsageResourceType,
    getRoutePathWithParams,
    getOrderLockedAction,
    logErrorToConsole,
} from 'src/utils/util';
import UnidHubOrderDeletePopup from 'src/pages/orders/components/unidHubOrderDeletePopup/UnidHubOrderDeletePopup';
import { useHistory } from 'react-router';
import { getCTAWCMSLink } from 'src/constants/wcmsRedirectionLinks';
import { setSearchParam } from 'src/pages/home/redux/actions';
import { CTA_IDS, isCopyCtaId, isTrueCopyCtaId, EQUITY, OrderStatuses, REPORT_PROCEDURE_DATA, NO_USAGE_REPORT, REPORT_USAGE } from 'src/constants/appConstants';
import {
    resetReportUsageStates,
    storeSurgeryDetails,
    cancelUsageOrderRequest,
    setShowNoUsageToReportOrCancelPopup,
    resetProgressBarStatus,
    resetDiscrepancyUsageDetails,
    reportPaymentClicked,
    setShippingDetails
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { getNumberOfDaysBetweenTwoDates } from 'src/utils/dateUtils';
import { sizes } from 'src/styles/Media.styled';
import {
    checkIfOrderLockedFunc,
    getOrderStatusDetailsFunc,
} from 'src/pages/reportUsage/redux/saga/dataServices';
import CancelAlertPopup from 'src/pages/reportUsage/common/cancelAlertPopup';
import { setActiveNavLink } from 'src/pages/home/redux/actions'; //for edit equity
import {
    fetchUsageDetailsRequest,
    getValidateAccountDetails,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import {
    getSurgeryDetails,
    resetBomData,
    resetCreateOrUpdateSurgery,
    resetShipToAddress,
    resetSurgeryDetails,
    resetSurgeryDetailsReducer,
    resetValidateAccountDetails,
} from 'src/pages/scheduleSurgery/redux/actions';
import { RESET_CANCEL_USAGE_STATES } from 'src/pages/reportUsage/redux/action/types';
import { useTranslation } from 'react-i18next';
import surgery from 'src/pages/scheduleSurgery/redux/reducers/surgery';
import { getConfigurations, resetNotes, setPediatricCheck } from 'src/common/redux/actions';
import {
    getCheckOrderActionEligibility,
    getCheckOrderActionEligibilityReset,
    triggerEventNotification
} from 'src/pages/orders/redux/actions';
import { reSetProgressBarStatus as resetProgressBarStatusSurgery } from 'src/pages/scheduleSurgery/redux/actions';
import { unlockOrderFunc } from 'src/pages/reportUsage/redux/saga/dataServices';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import {
    getEquityDetails,
    resetEquityDetails,
} from 'src/pages/equity/redux/actions';
import { GETEQUITYDETAILSDATA } from 'src/constants/productConstants';
import {
    resetConsignmentAddDetails,
} from 'src/pages/consignmentAdd/redux/actions';
import TorqueQRCode from 'src/common/refactoredComponents/torqueQRCode';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import { setQrGenerated } from 'src/common/redux/actions';

const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: 9999999,
        top: '-18px!important',
        width: '215px',
        left: '5px!important',
        boxShadow: '0px 0px 12px #00000029',
        border: '1px solid #D4D4FB',
        background: '#FFFFFF',
        opacity: 1,
        borderRadius: '3px',
        '&:after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            bottom: '-6px',
            right: ({ right }) => (right === true ? '100px' : '75px'),
            width: '10px',
            height: '10px',
            background: '#FFFFFF',
            borderRight: '1.1px solid #D4D4FB',
            borderBottom: '1.1px solid #D4D4FB',
            transform: 'rotate(45deg)',
        },
    },
    typography: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1),
        borderTop: '1px solid rgba(112,112,112, 0.12)',
        textAlign: 'left',
        fontFamily: 'AvenirNextWorld Regular',
        letterSpacing: '0px',
        color: '#222222',
        opacity: '1',
        cursor: 'pointer',
        fontSize: '14px',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        '&:first-child': {
            borderTop: 'none',
        },
    },
    papper: {
        boxShadow: 'none !important',
    },
}));

const OrderDetailFooter = ({
    fromCalendar,
    fromListScreen,
    isOrderHistory = false,
    toggleViewTemplate,
    setCurrentActivity = () => { },
    retriggerEventNotification,
    setRetriggerEventNotification,
    setNotificationDetails,
    notificationDetails,
    isFromPhysicianDetails,
    onAssignTerritory
}) => {
    const [moreActionAnchorEl, setMoreActionAnchorEl] = useState(null);
    const [moreActionOpen, setMoreActionOpen] = React.useState(false);
    const { t } = useTranslation();
    const [deleteNotAllowedPopupOpen, setDeleteNotAllowedPopupOpen] =
        useState(false);
    const [, setTableRowData] = useState(null);
    const [, setTableListRowData] = useState(null);

    const [showOrderLockedPopup, setShowOrderLockedPopup] = useState({
        show: false,
        myCaseRef: null,
        modifiedBy: null,
    });
    const validateAccount = useSelector(
        (state) => state.surgeryvalidateAccountReducer.validateAccount
    );
    const {qrCodeData ,qrCodeLoading, qrCodeError, qrGenerated} = useSelector((state) => state.qrCodeReducer);
    const [isEdit, setIsEdit] = useState(false);
    const [isFutureDatedOrder, setIsFutureDatedOrder] = useState(false);
    const [showTorqueQR, setShowTorqueQR] = useState(false);
    const [torqueQRParams, setTorqueQRParams] = useState(null);
    const dispatch = useDispatch();
    // const classes = useStyles();
    const history = useHistory();
    const { isAllowed, statusCode } = useSelector((state) => state.checkOrderActionEligibilityReducer);
    const activeNavLink = useSelector((state) => state.navLinkReducer);

    const location = useLocation();
    const handleClick = (event) => {
        if (orderListCallActions.length > 0) {
            setMoreActionAnchorEl(event.currentTarget);
            setMoreActionOpen(true);
        } else {
            setMoreActionOpen(false);
        }

        // setMoreActionOpen((prev) => !prev);
    };
    const isMobile = isMobileDevice();
    const {
        callToActionList: rawCallToActionList,
        orderBasicDetails,
        createdBy,
        selectedTabId,
        orderSummaryModal,
    } = useSelector((state) => state.orderSummaryReducer);
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const { currentOrderType, accountNumber, orderStatusDescription } =
        orderBasicDetails || {};
    const isConsignmentAddOrder = currentOrderType === 'KB';
    const isSurgeryOrder =
        currentOrderType === 'ZLC' || currentOrderType === 'ZLB';
    const isOrderHistoryContext =
        !!isOrderHistory ||
        !!location?.state?.isFromOrderHistory ||
        !!location?.pathname?.includes('/orderHistory');

    const getCopyCtaLabel = () => {
        const key = 'orders.orderListView.copyLabel';
        const label = t(key);
        return label && label !== key ? label : 'Copy';
    };

    const callToActionList = (Array.isArray(rawCallToActionList)
        ? rawCallToActionList
        : []
    ).filter(
        (cta) =>
            !(
                isOrderHistory &&
                orderBasicDetails?.currentOrderType === 'ZOR' &&
                countryISOCode !== 'US' &&
                isCopyCtaId(cta?.ctaId)
            )
    );

    const loggedInUser = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.displayName
    );

    const loggedInUserDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails
    );
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );

    const myCaseRef = useSelector(
        (state) => state.orderSummaryReducer.myCaseRef
    );
    const orderCard = useSelector(
        (state) => state.ordersReducer.cardData.orderData
    );
    const orderListData = useSelector(
        (state) => state.ordersReducer.listData.orderData
    );
    const searchCalendarData = useSelector(
        (state) => state.ordersReducer.searchCardData.orderData
    );
    const {
        deliveryCheckEdit,
        deliveryCheckNoUsageToReport
    } = useSelector((state) => state.loginReducer);
    const { orderList } = useSelector((state) => state.ordersListReducer);

    const { searchResultOrderList } = useSelector(
        (state) => state.appliedOrdersSearchReducer
    );

    let order = orderList?.find((order) => {
        return order.myCaseRef === myCaseRef;
    });

    let orderView = orderCard?.find((order) => {
        return order.myCaseRef === myCaseRef;
    });
    let orderListView = orderListData?.find((order) => {
        return order.myCaseRef === myCaseRef;
    });

    if (!order) {
        order = searchResultOrderList?.find((order) => {
            return order.myCaseRef === myCaseRef;
        });
    }

    if (
        (fromCalendar || fromListScreen) &&
        (!orderView || !orderListView) &&
        searchCalendarData?.length &&
        searchCalendarData.length > 0
    ) {
        if (fromCalendar === true && fromListScreen === false) {
            orderView = searchCalendarData?.find((order) => {
                return order.myCaseRef === myCaseRef;
            });
        } else if (fromCalendar === true && fromListScreen === true) {
            orderListView = searchCalendarData?.find((order) => {
                return order.myCaseRef === myCaseRef;
            });
        }
    }
    const [blockedAccountMessagePopUp, setBlockedAccountMessagePopUp] =
        useState(false);
    const [tempValidationData, setTempValidationData] = useState({});
    const [showReportUsageBlockPopUp, setShowReportUsageBlockPopUp] =
        useState(false);
    useEffectWithErrorLogging(() => {
        if (
            validateAccount.data.blockMessage &&
            showReportUsageBlockPopUp === false
        ) {
            setShowReportUsageBlockPopUp(true);
        }
    }, [validateAccount]);

    
    useEffectWithErrorLogging(() => {

        if (
            validateAccount.data &&
            validateAccount?.statusCode?.length > 0 &&
            !validateAccount.data.hasOwnProperty('blockMessage') &&
            tempValidationData.hasOwnProperty('name') &&
            tempValidationData.hasOwnProperty('row')
        ) {
            navigateToReportUsage(
                tempValidationData.row,
                tempValidationData.name
            );
            setTempValidationData({});
        }
    }, [validateAccount, tempValidationData, isAllowed]);
    useEffectWithErrorLogging(() => {
        if (
            validateAccount.data.blockMessage &&
            blockedAccountMessagePopUp === false
        ) {
            setBlockedAccountMessagePopUp(true);
        }
    }, [validateAccount]);
    useEffectWithErrorLogging(() => {
        dispatch(resetValidateAccountDetails());
    }, []);
    const handlePrimaryCTA = () => {
        return getDefaultCTAId(
            {
                orderStatusDescription: orderStatusDescription,
                callToActionList: callToActionList,
            },
            false,
            callToActionList
        );
    };
    const primaryCTAId = handlePrimaryCTA();

    const primaryCTAObject = {};
    const handleEventRetrigger =(myCaseRef,orderType)=>
    {
        const data={myCaseRef:myCaseRef,
            orderType:orderType
        };
         dispatch(triggerEventNotification(data,true));
    };
    const handleOrderListCallActions = () => {
        if (
            callToActionList &&
            callToActionList?.length &&
            callToActionList.length > 0
        ) {
            if (isConsignmentAddOrder) {
                const copyLabel = (getCopyCtaLabel() || 'Copy').toLowerCase();
                const copyAction = callToActionList.find(
                    (x) =>
                        isCopyCtaId(x?.ctaId) ||
                        (typeof x?.ctaName === 'string' &&
                            x.ctaName.trim().toLowerCase() === copyLabel)
                );
                return copyAction ? [copyAction] : [];
            }
            if (selectedTabId === 'procedureData') {
                return callToActionList.filter(
                    (x) =>
                        ((currentOrderType === 'ZOR' || isSurgeryOrder) && isOrderHistoryContext ? true : x.ctaId !== primaryCTAId) &&
                        x.ctaId !== 'CTA_001' &&
                        x.ctaId !== 'CTA_014' &&
                        x.ctaId !== 'CTA_022'
                );
            } else {
                return callToActionList.filter(
                    (x) =>
                        ((currentOrderType === 'ZOR' || isSurgeryOrder) && isOrderHistoryContext ? true : x.ctaId !== primaryCTAId) &&
                        x.ctaId !== 'CTA_001' &&
                        x.ctaId !== 'CTA_014'
                );
            }
        } else {
            return [];
        }
    };

    let orderListCallActions = handleOrderListCallActions();
    
    if (
        orderBasicDetails?.currentOrderType === 'ZOR' && //for equity
        primaryCTAId !== null &&
        primaryCTAId !== 'CTA_001'
    ) {
        if (
            callToActionList &&
            callToActionList?.length &&
            callToActionList.length > 0
        ) {
            const primaryCTAIndex = callToActionList.findIndex(
                (x) => x.ctaId === primaryCTAId
            );
            if (primaryCTAIndex >= 0) {
                primaryCTAObject.ctaId =
                    callToActionList[primaryCTAIndex].ctaId;
                primaryCTAObject.ctaName =
                    callToActionList[primaryCTAIndex].ctaName;
            }
        }
    }
    const ctaDetails = useSelector((state) => state.ctaDataReducer);

    const classes = useStyles({
        right: orderListCallActions.some((option) =>
            option.ctaName === 'Case Cancelled/Postponed' ? true : false
        ),
    });

    if (
        orderBasicDetails?.currentOrderType !== 'ZOR' && //added this condition to skip equity
        !(isOrderHistoryContext && orderBasicDetails?.currentOrderType === 'KB') &&
        primaryCTAId !== null &&
        primaryCTAId !== 'CTA_001' &&
        primaryCTAId !== 'CTA_014'
    ) {
        if (
            callToActionList &&
            callToActionList?.length &&
            callToActionList.length > 0
        ) {
            const primaryCTAIndex = callToActionList.findIndex(
                (x) => x.ctaId === primaryCTAId
            );
            if (primaryCTAIndex >= 0) {
                primaryCTAObject.ctaId =
                    callToActionList[primaryCTAIndex].ctaId;
                primaryCTAObject.ctaName =
                    callToActionList[primaryCTAIndex].ctaName;
            }
        }
    }

    if (
        orderBasicDetails?.currentOrderType === 'ZKA' && //added this condition to skip equity
        primaryCTAId !== null
        // &&
        // primaryCTAId !== 'CTA_001' &&
        // primaryCTAId !== 'CTA_014'
    ) {
        if (
            callToActionList &&
            callToActionList?.length &&
            callToActionList.length > 0
        ) {
            const primaryCTAIndex = callToActionList.findIndex(
                (x) => x.ctaId === primaryCTAId
            );
            if (primaryCTAIndex >= 0) {
                primaryCTAObject.ctaId =
                    callToActionList[primaryCTAIndex].ctaId;
                primaryCTAObject.ctaName =
                    callToActionList[primaryCTAIndex].ctaName;
            }
        }
    }

    const getWCMSRedirectionLink = (order, cta) => {
        return getCTAWCMSLink(order, cta);
    };

    const editSurgery = (myCaseRef) => {
        if (!isAllowed && deliveryCheckEdit === VISIBLE) { return; }
        // dispatch(
        //     closeOrderSummaryModalState({
        //         myCaseRef: '',
        //         orderSummaryModal: false,
        //     })
        // );
        dispatch(resetSurgeryDetailsReducer());
        dispatch(resetCreateOrUpdateSurgery());
        dispatch(resetSurgeryDetails());
        dispatch(resetShipToAddress());
        dispatch(resetBomData());
        dispatch(resetProgressBarStatusSurgery());
        dispatch(setPediatricCheck(''));
        dispatch(resetNotes());
        dispatch(setSearchParam(''));
        // This footer is an overlay modal whose location.pathname doesn't change
        // depending on where it was opened from, so use the fromCalendar prop
        // (explicitly passed by every caller: orders listing, submission summary
        // screens, etc.) as the source of truth for the nav origin instead.
        const isOrdersOrigin = fromCalendar === false;
        if (isOrdersOrigin) {
            dispatch(setActiveNavLink({ calendar: false, orders: true }));
        }
        history.push({
            ...getRoutePathWithParams(`/modifySurgery/${myCaseRef}`),
            state: {
                from: location?.pathname ? location.pathname : null,
                ...(isOrdersOrigin ? { navOrigin: 'orders' } : null),
            },
        });
    };
    useEffectWithErrorLogging(() => {
        if (isEdit && isAllowed && surgeryEdit) {
            editSurgery(surgeryEdit);
            setSurgeryEdit(false); // reset after navigation
        }
    }, [isAllowed, surgeryEdit, isEdit]);
    //Equity
    const editEquity = (myCaseRef, accountName) => {
        dispatch(
            closeOrderSummaryModalState({
                myCaseRef: '',
                orderSummaryModal: false,
            })
        );
        dispatch(setSearchParam(''));
        dispatch(setActiveNavLink({ calendar: false, orders: true }));
        history.push({
            ...getRoutePathWithParams(`/modifyEquity/${myCaseRef}`),
            state: {
                from: location?.pathname ? location.pathname : null,
                account: accountName,
            },
        });
    };
    const [surgeryEdit, setSurgeryEdit] = useState(false);
    useEffectWithErrorLogging(() => {
        if (!isAllowed && statusCode === '13202') {
            setSurgeryEdit(false);  // if Allowed then navigate to Modify Surgery
        }
        if (
            validateAccount.data.blockMessage ||
            validateAccount.statusCode === '' ||
            !surgeryEdit
        ) {
            return;
        }
        editSurgery(surgeryEdit);
    }, [validateAccount, surgeryEdit, isAllowed]);

    //Transfer Surgery
    const transferSurgery = (myCaseRef) => {
        dispatch(
            closeOrderSummaryModalState({
                myCaseRef: '',
                orderSummaryModal: false,
            })
        );
        dispatch(setSearchParam('')); 
        dispatch(resetCreateOrUpdateSurgery());
        dispatch(resetProgressBarStatusSurgery()); 
        if( location?.pathname.includes('/transferSurgery')){  
            setTimeout(()=>{    
                window.location.reload(); 
            },100);
        } 
        else{
        history.push({
            ...getRoutePathWithParams(`/transferSurgery/${myCaseRef}`),
            state: { from: location?.pathname ? location.pathname : null },
        });
        }
    };

    const navigateToReportUsage = (rowData, ctaID) => { 
        setCurrentActivity('Record');
        dispatch(resetProgressBarStatus());
        dispatch(resetReportUsageStates());
        dispatch(setShippingDetails([]));
        dispatch(
            resetReportUsageStates(
                location?.pathname ===
                `/reportUsage/${rowData?.myCaseRef || myCaseRef}`
            )
        );

        const reportUsageObj = {
            resourceType: getReportUsageResourceType(
                orderStatusDescription
                    ? orderStatusDescription
                    : rowData?.orderStatusDescription,
                ctaID
            ),
            myCaseRef: rowData?.myCaseRef || myCaseRef,
            fromOrdersList: !fromCalendar,
            isFromOrderDetailsModal: true,
        };
        dispatch(storeSurgeryDetails(reportUsageObj));
        localStorage.setItem('myCaseRefUsage', JSON.stringify(reportUsageObj));
        dispatch(getOrderSummaryData());
        dispatch(
            setOrderSummaryModalState({
                myCaseRef: rowData?.myCaseRef || myCaseRef,
                orderSummaryModal: false,
            })
        );
        if (
            location?.pathname ===
            `/reportUsage/${rowData?.myCaseRef || myCaseRef}`
        ) {
            // Page doesn't remount here, and the order-summary (ORDERS) config overwrote the usage rules (e.g. replenishment visibility).
            dispatch(
                getConfigurations(
                    { resourceType: 'visibility', module: REPORT_USAGE },
                    REPORT_USAGE
                )
            );
        } else {
            history.push({
                ...getRoutePathWithParams(
                    `/reportUsage/${rowData?.myCaseRef || myCaseRef}`
                ),
                state: {
                    from: location?.pathname ? location.pathname : null,
                    myCaserefId: rowData?.myCaseRef || myCaseRef,
                },
            });
        }
    };
    const deleteOrderHandler = () => {
        const createdByUserId = createdBy;
        dispatch(
            showDeleteOrderAction({
                isDeletePopup: true,
                deleteMyCaseRef: myCaseRef,
                isOrderDetailsModal: true,
                isOtherUser:
                    loggedInUserDetails?.uid &&
                        loggedInUserDetails.uid !== createdByUserId
                        ? loggedInUserDetails.displayName !== createdByUserId
                            ? true
                            : false
                        : false,
            })
        );
        dispatch(
            showHideSummaryModal({
                orderSummaryModal: false,
            })
        );
    };

    const deleteOrderValidation = () => {
        if (fromCalendar === true && fromListScreen === false) {
            orderView?.unidCaseNo || orderView?.unidCaseId
                ? setDeleteNotAllowedPopupOpen(true)
                : deleteOrderHandler();
        } else if (fromCalendar === true && fromListScreen === true) {
            orderListView?.unidCaseNo || orderView?.unidCaseId
                ? setDeleteNotAllowedPopupOpen(true)
                : deleteOrderHandler();
        } else {
            order?.unidCaseId
                ? setDeleteNotAllowedPopupOpen(true)
                : deleteOrderHandler();
        }
    };
    const handleCloseDeliveryCheckPopUp = (status) => {
        dispatch(getCheckOrderActionEligibilityReset());
        (myCaseRef && myCaseRef?.length > 0) && unlockOrderFunc({
            action: status === 'edit' ? 'SubmittedSurgeryEdit' : 'NoUsageToReport',
            myCaseRefId: myCaseRef,
        });
    };

    const handleNoReportUsageCancellation = () => {
        dispatch(
            cancelUsageOrderRequest(
                { myCaseRef: myCaseRef },
                true,
                true
            )
        );
        dispatch(getCheckOrderActionEligibilityReset());
    };
    const onMoreActionsSelectHandler = async (name, isMoreAction, ctaName) => {
        const isCopyCTA =
            isCopyCtaId(name) &&
            (isOrderHistoryContext || isTrueCopyCtaId(name));
        if (isCopyCTA) {
            if (isMoreAction) {
                setMoreActionOpen(false);
            }
            const isConsignmentAddOrder = currentOrderType === 'KB';
            if (currentOrderType === 'ZOR') {
                dispatch(
                    closeOrderSummaryModalState({
                        myCaseRef: '',
                        orderSummaryModal: false,
                    })
                );
                dispatch(resetEquityDetails());
                // Reserve a brand new equity reference (creation call) so the
                // copied order is created as a distinct new order.
                dispatch(getEquityDetails(GETEQUITYDETAILSDATA));
                dispatch(setSearchParam(''));
                dispatch(
                    setActiveNavLink(
                        isOrderHistoryContext
                            ? { calendar: false, orders: false, inventory: false, more: true }
                            : { calendar: false, orders: true, inventory: false, more: false }
                    )
                );
                history.push({
                    ...getRoutePathWithParams(`/modifyEquity/${myCaseRef}`),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                        account: orderBasicDetails?.accountName,
                        sourceMyCaseRef: myCaseRef,
                        sourceOrderType: currentOrderType,
                        isFromOrderHistory: isOrderHistoryContext,
                        isCopyFromSummary: !isOrderHistoryContext,
                    },
                });
                return;
            }
            if (isConsignmentAddOrder) {
                dispatch(
                    closeOrderSummaryModalState({
                        myCaseRef: '',
                        orderSummaryModal: false,
                    })
                );
                dispatch(resetConsignmentAddDetails());
                    dispatch(setSearchParam(''));
                dispatch(
                    setActiveNavLink(
                        isOrderHistoryContext
                            ? { calendar: false, orders: false, inventory: false, more: true }
                            : { calendar: false, orders: true, inventory: false, more: false }
                    )
                );
                history.push({
                    ...getRoutePathWithParams(
                        '/consignmentAdd'
                    ),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                        account: orderBasicDetails?.accountName,
                        sourceMyCaseRef: myCaseRef,
                        sourceOrderType: currentOrderType,
                        isFromOrderHistory: isOrderHistoryContext,
                        isCopyFromSummary: !isOrderHistoryContext,
                    },
                });
                return;
            }
            // ZLC / ZLB "Copy" -> /scheduleSurgery
            if (
                currentOrderType !== 'ZOR' &&
                !isConsignmentAddOrder
            ) {
                dispatch(
                    closeOrderSummaryModalState({
                        myCaseRef: '',
                        orderSummaryModal: false,
                    })
                );
                dispatch(resetSurgeryDetails());
                dispatch(setSearchParam(''));
                // The submission/success screen itself lives on /scheduleSurgery,
                // so when Copy is invoked from there location.pathname is
                // '/scheduleSurgery' and location.state.from may no longer reflect
                // the true origin. In that case the currently active nav link (set
                // when the order was first created) is the reliable source of
                // truth, so derive the origin from it to keep it selected.
                const isFromSubmissionScreen = (location?.pathname || '').includes('/scheduleSurgery');
                const isOrdersOrigin = isFromSubmissionScreen
                    ? !!activeNavLink?.orders
                    : (location?.pathname || '').includes('/orders') ||
                      (location?.state?.from || '').includes('/orders');
                const navOrigin = isOrderHistoryContext
                    ? 'more'
                    : isFromSubmissionScreen && activeNavLink?.more
                    ? 'more'
                    : isOrdersOrigin
                    ? 'orders'
                    : 'calendar';
                dispatch(
                    setActiveNavLink(
                        isOrderHistoryContext
                            ? { calendar: false, orders: false, inventory: false, more: true }
                            : navOrigin === 'more'
                            ? { calendar: false, orders: false, inventory: false, more: true }
                            : navOrigin === 'orders'
                            ? { calendar: false, orders: true, inventory: false, more: false }
                            : { calendar: true, orders: false, inventory: false, more: false }
                    )
                );
                // Once an order has been submitted, copying it again from the
                // submission screen must always use the regular summary API
                // (not orderHistorySummary), regardless of where the original
                // order was first opened from. The submitted order now exists as
                // a real order, so treat the copy source as a normal summary.
                const copyIsFromOrderHistory = isFromSubmissionScreen
                    ? false
                    : isOrderHistoryContext;
                history.push({
                    ...getRoutePathWithParams('/scheduleSurgery'),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                        navOrigin,
                        sourceMyCaseRef: myCaseRef,
                        sourceOrderType: currentOrderType,
                        sourceIsMastOrder: !!orderBasicDetails?.isMastOrder,
                        isFromOrderHistory: copyIsFromOrderHistory,
                        isCopyFromSummary: !copyIsFromOrderHistory,
                        account: orderBasicDetails?.accountName,
                    },
                });
                return;
            }
            dispatch(
                closeOrderSummaryModalState({
                    myCaseRef: '',
                    orderSummaryModal: false,
                })
            );
            dispatch(setSearchParam(''));
            const isEquityOrder = currentOrderType === 'ZOR';
            dispatch(
                setActiveNavLink({
                    calendar: !isEquityOrder && !isConsignmentAddOrder,
                    orders: isEquityOrder,
                    inventory: isConsignmentAddOrder,
                })
            );
            history.push({
                ...getRoutePathWithParams(
                    isEquityOrder
                        ? '/equity'
                        : isConsignmentAddOrder
                        ? '/consignmentAdd'
                        : '/scheduleSurgery'
                ),
                state: {
                    from: location?.pathname ? location.pathname : null,
                    sourceMyCaseRef: myCaseRef,
                    sourceOrderType: currentOrderType,
                    sourceIsMastOrder: !!orderBasicDetails?.isMastOrder,
                    isFromOrderHistory: isOrderHistoryContext,
                },
            });
            return;
        }
        name === 'CTA_022' && dispatch(getConfigurations(
            { resourceType: 'visibility', module: EQUITY },
            REPORT_PROCEDURE_DATA
        ));
        name === 'CTA_007' && dispatch(getConfigurations(
            { resourceType: 'visibility', module: NO_USAGE_REPORT },
            NO_USAGE_REPORT
        ));
        dispatch(resetNotes());
        dispatch(setPediatricCheck(''));
        let rowData = {};
        if (fromCalendar && !fromListScreen) {
            rowData = orderView;
        } else if (fromCalendar && fromListScreen) {
            rowData = orderListView;
        } else {
            rowData = order ? order : {};
        }

        if (!rowData?.myCaseRef) {
            rowData = { ...rowData, myCaseRef };
        }

        if (isMoreAction) {
            setMoreActionOpen((prev) => !prev);
        }
        dispatch({ type: RESET_CANCEL_USAGE_STATES });
        let orderLockedData, orderStatus;
        const orderLockAction = getOrderLockedAction(
            name,
            currentOrderType,
            rowData?.orderStatusDescription
                ? rowData?.orderStatusDescription
                : orderStatusDescription
        );
        if (
            name === CTA_IDS.editOrder &&
            ctaDetails.orderStatus ===
            t('orders.orderQuickFilters.usageOrders.inProcess')
        ) {
            const SURGERYVALIDATEACCOUNT = {
                orderType: 'ZLC',
                sapPartnerId: accountNumber.toString().padStart(10, '0'),
            };
            dispatch(getValidateAccountDetails(SURGERYVALIDATEACCOUNT));
        }
        if (
            orderLockAction &&
            ((name === CTA_IDS.editOrder &&
                currentOrderType === 'ZLC' &&
                process.env.ENABLE_SCHEDULE_SURGERY) ||
                ((((name === CTA_IDS.editOrder ||
                    name === CTA_IDS.reportPayment) &&
                    currentOrderType === 'ZLB') ||
                    name === CTA_IDS.reportUsage) &&
                    process.env.ENABLE_REPORT_USAGE) ||
                (process.env.ENABLE_NO_USAGE_TO_REPORT &&
                    loggedInUserDetails &&
                    (name === CTA_IDS.noUsageToReport ||
                        name === CTA_IDS.unidPostponed) &&
                    rowData))
        ) {
            orderLockedData = await checkIfOrderLockedFunc({
                action: orderLockAction,
                myCaseRefId: rowData?.myCaseRef || myCaseRef,
                orderType:
                    orderLockAction === 'ReportUsage'
                        ? 'ZLB'
                        : currentOrderType,
            });
            if (name === CTA_IDS.reportUsage || name === CTA_IDS.reportPayment) {
                const SURGERYVALIDATEACCOUNT = {
                    orderType: 'ZLC',
                    sapPartnerId: accountNumber.toString().padStart(10, '0'),
                };
                dispatch(getValidateAccountDetails(SURGERYVALIDATEACCOUNT));
                orderStatus = name !== CTA_IDS.reportPayment && await getOrderStatusDetailsFunc(
                    rowData?.myCaseRef || myCaseRef
                );
            }
        }

        if (
            //DELETE
            name === CTA_IDS.delete &&
            (currentOrderType === 'ZLC' ||
                currentOrderType === 'ZLB' ||
                currentOrderType === 'ZOR')
        ) {
            deleteOrderValidation();
        } else if (
            //EDIT
            name === CTA_IDS.editOrder &&
            currentOrderType === 'ZLC' &&
            process.env.ENABLE_SCHEDULE_SURGERY
        ) {
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : myCaseRef,
                    modifiedBy: orderLockedData?.user,
                });
            } else {
                //editSurgery(myCaseRef);
                //checkDelivery for edit
                if (name === CTA_IDS.editOrder) {
                    //check for delivery eligibility
                    if (deliveryCheckEdit === VISIBLE) {
                        const deliveryCheckPayload = {
                            orderType: 'ZLC',
                            action: 'edit',
                            myCaseRef: rowData.myCaseRef
                        };
                        setIsEdit(true);
                        setSurgeryEdit(rowData.myCaseRef);
                        dispatch(
                            getCheckOrderActionEligibility(
                                deliveryCheckPayload
                            )
                        );
                    }
                    else {
                        dispatch(resetSurgeryDetails());
                        editSurgery(rowData.myCaseRef);
                    }
                }
                if (
                    name === CTA_IDS.editOrder &&
                    ctaDetails.orderStatus ===
                    t('orders.orderQuickFilters.usageOrders.inProcess')
                ) {
                    const SURGERYVALIDATEACCOUNT = {
                        orderType: 'ZLC',
                        sapPartnerId: accountNumber
                            .toString()
                            .padStart(10, '0'),
                    };
                    dispatch(getValidateAccountDetails(SURGERYVALIDATEACCOUNT));
                    setSurgeryEdit(myCaseRef);
                }
            }
        } else if (
            //Request Invoice
            name === CTA_IDS.requestInvoice &&
            (currentOrderType === 'ZLC' ||
                currentOrderType === 'ZLB' ||
                currentOrderType === 'ZOR' ||
                currentOrderType === 'KE' ||
                currentOrderType === 'KB')
        ) {
            dispatch(
                showHideRequestInvoice({
                    requestInvoiceState: true,
                    myCaseRefId: myCaseRef,
                    isRequestInvoiceOrderListPage: false,
                    isRequestInvoiceSearchListPage: false,
                })
            );
            dispatch(
                showHideSummaryModal({
                    orderSummaryModal: false,
                })
            );
        } else if (
            (((name === CTA_IDS.editOrder || name === CTA_IDS.reportPayment) &&
                currentOrderType === 'ZLB') ||
                name === CTA_IDS.addReportUsage ||
                name === CTA_IDS.reportUsage) &&
            process.env.ENABLE_REPORT_USAGE
        ) {
            if (
                orderLockedData?.isOrderLocked ||
                (orderStatus?.statusDescription === 'Records Found' &&
                    !orderStatus?.status?.includes('Exception') &&
                    (orderStatus.status.includes(
                        'Usage Order Submitted Successfully'
                    ) ||
                        orderStatus.status.toLowerCase().includes('process')))
            ) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData?.myCaseRef,
                    modifiedBy: orderLockedData?.user
                        ? orderLockedData?.user
                        : orderStatus?.userId,
                });
            } else {
                name === CTA_IDS.reportPayment && dispatch(reportPaymentClicked(true));
                if (name === CTA_IDS.reportUsage || name === CTA_IDS.reportPayment || name === CTA_IDS.addReportUsage) {
                    const SURGERYVALIDATEACCOUNT = {
                        orderType: 'ZLC',
                        sapPartnerId: accountNumber
                            .toString()
                            .padStart(10, '0'),
                    };
                    dispatch(getValidateAccountDetails(SURGERYVALIDATEACCOUNT));
                    if (!validateAccount?.data?.blockMessage) {
                        setTempValidationData({
                            row: rowData,
                            name: name,
                        });
                    }
                } else {
                    navigateToReportUsage(rowData, name);
                }
            }
        }else if (name === CTA_IDS.retriggerNotification ) {
                 setRetriggerEventNotification('fromSummary');
                 setNotificationDetails({ orderType:rowData?.currentOrderType, myCaseRef:rowData.myCaseRef});
         } else if (name === 'CTA_026') {
            // Torque QR Code
            setTorqueQRParams({ myCaseRef: rowData?.myCaseRef || myCaseRef });
            setShowTorqueQR(true);
        } else if (name === CTA_IDS.editOrder && currentOrderType === 'ZOR') {
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData?.myCaseRef,
                    modifiedBy: orderLockedData?.user,
                });
            } else {
                // dispatch(
                //     resetReportUsageStates(
                //         location?.pathname ===
                //             `/reportUsage/${rowData?.myCaseRef || myCaseRef}`
                //     )
                // );
                // navigateToReportUsage(rowData, name);
                editEquity(myCaseRef, rowData.accountName);
            }
        } else if (
            name === CTA_IDS.viewAdjustments &&
            (rowData?.currentOrderType === 'ZLC' ||
                rowData?.currentOrderType === 'ZLB' ||
                rowData?.currentOrderType === 'ZOR')
        ) {
            dispatch(
                setOrderSummaryTabAction({
                    selectedTabId: OrderSummaryTabs()[4].id,
                })
            );
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef: rowData.myCaseRef,
                    orderSummaryModal: orderSummaryModal,
                })
            );
        } else if (
            process.env.ENABLE_NO_USAGE_TO_REPORT &&
            loggedInUserDetails &&
            name === CTA_IDS.noUsageToReport &&
            rowData
        ) {
            //check for delivery eligibility
            if (deliveryCheckNoUsageToReport === VISIBLE) {
                const deliveryCheckPayload = {
                    orderType: 'ZLC',
                    action: 'cancel',
                    myCaseRef: rowData.myCaseRef
                };
                dispatch(
                    getCheckOrderActionEligibility(
                        deliveryCheckPayload
                    )
                );
            }
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData?.myCaseRef,
                    modifiedBy: orderLockedData?.user,
                });
            } else {
                const diffBetweenDates = getNumberOfDaysBetweenTwoDates(
                    new Date(),
                    rowData.surgeryDate ||
                    rowData.surgeryStartDate ||
                    orderBasicDetails.surgeryDate ||
                    ''
                );
                const createdByUserId = rowData.createdBy || createdBy;
                if (
                    diffBetweenDates <= 0 ||
                    (createdByUserId !== loggedInUserDetails.uid &&
                        createdBy !== loggedInUser)
                ) {
                    dispatch(
                        setShowNoUsageToReportOrCancelPopup({
                            showNoUsagePopup:
                                createdByUserId === loggedInUserDetails.uid ||
                                loggedInUserDetails.displayName ===
                                createdByUserId,
                            showCancelPopup:
                                createdByUserId !== loggedInUserDetails.uid
                                    ? loggedInUserDetails.displayName !==
                                        createdByUserId
                                        ? true
                                        : false
                                    : false,
                            surgeryData: {
                                myCaseRef: myCaseRef,
                                ...rowData,
                                createdBy: createdByUserId,
                            },
                            viewProcedureScreen: false,
                            isFromOrderDetailsModal: true,
                            showCaseCancelOrPostpone: false,
                        })
                    );
                } else if (
                    diffBetweenDates > 0 &&
                    (createdByUserId === loggedInUserDetails.uid ||
                        createdBy === loggedInUser)
                ) {
                    if (deliveryCheckEdit === VISIBLE) {
                        setIsFutureDatedOrder(true);
                    }
                    else {
                        dispatch(
                            cancelUsageOrderRequest(
                                {
                                    myCaseRef: rowData.myCaseRef
                                        ? rowData.myCaseRef
                                        : myCaseRef,
                                },
                                true,
                                true
                            )
                        );
                    }
                }
            }
        } else if (
            process.env.ENABLE_NO_USAGE_TO_REPORT &&
            loggedInUserDetails &&
            name === CTA_IDS.caseCancelOrPostpone &&
            rowData
        ) {
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData.myCaseRef,
                    modifiedBy: orderLockedData?.user,
                    action: orderLockAction,
                });
            } else {
                dispatch(
                    getSurgeryDetails(rowData.myCaseRef, true, false, true)
                );
                dispatch(
                    setShowNoUsageToReportOrCancelPopup({
                        showNoUsagePopup: false,
                        showCancelPopup: false,
                        surgeryData: rowData,
                        viewProcedureScreen: false,
                        showCaseCancelOrPostpone: true,
                        isFromOrderDetailsModal: true,
                    })
                );
            }
        } else if (
            process.env.ENABLE_NO_USAGE_TO_REPORT &&
            loggedInUserDetails &&
            name === CTA_IDS.unidPostponed &&
            rowData
        ) {
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData.myCaseRef,
                    modifiedBy: orderLockedData?.user,
                });
            } else {
                // const diffBetweenDates = getNumberOfDaysBetweenTwoDates(
                //     new Date(),
                //     rowData.surgeryDate
                // );
                const createdByUserId = rowData.createdBy || createdBy;
                // if (
                //     diffBetweenDates <= 0 ||
                //     createdByUserId !== loggedInUserDetails.uid
                // ) {
                dispatch(
                    getSurgeryDetails(rowData.myCaseRef, true, false, true)
                );
                dispatch(
                    setShowNoUsageToReportOrCancelPopup({
                        showNoUsagePopup: false,
                        showCancelPopup: false,
                        surgeryData: {
                            ...rowData,
                            createdBy: createdByUserId,
                        },
                        viewProcedureScreen: false,
                        showUnidPostponePopup: true,
                        isFromOrderDetailsModal: true,
                        showCaseCancelOrPostpone: false,
                    })
                );
                // } else if (
                //     diffBetweenDates > 0 &&
                //     createdByUserId === loggedInUserDetails.uid
                // ) {
                //     dispatch(
                //         cancelUsageOrderRequest(
                //             { myCaseRef: rowData.myCaseRef },
                //             true,
                //             true
                //         )
                //     );
                // }
            }
        } else if (
            //View Usage Report
            name === CTA_IDS.viewUsageReports &&
            (currentOrderType === 'ZLC' || currentOrderType === 'ZLB')
        ) {
            dispatch(resetDiscrepancyUsageDetails());
            dispatch(
                setSendReportModalState({
                    showModal: true,
                    myCaseRefId: myCaseRef,
                    isUsageReportSearchListPage: false,
                })
            );
            const orderStatus = rowData?.orderStatusDescription
                ? rowData?.orderStatusDescription
                : orderStatusDescription;
            if (
                orderStatus === OrderStatuses().paymentInformationNeeded ||
                orderStatus === OrderStatuses().billingIssues
            ) {
                dispatch(
                    fetchUsageDetailsRequest({
                        resourceType: 'reportPayment',
                        myCaseRef: myCaseRef,
                        isDiscrepencyCheck: true,
                    })
                );
            }
            dispatch(
                showHideSummaryModal({
                    orderSummaryModal: false,
                })
            );
        } else if (
            // save as template
            (name === CTA_IDS.createTemplate || name === 'CTA2') &&
            (currentOrderType === 'ZLC' ||
                currentOrderType === 'ZLB' ||
                currentOrderType === 'ZOR')
        ) {
            if (fromCalendar === true && fromListScreen === false) {
                setTableRowData(orderView);
            } else if (fromCalendar === true && fromListScreen === true) {
                setTableListRowData(orderListView);
            } else {
                setTableRowData(order);
            }
            toggleViewTemplate();
        } else if (
            //TRANSFER Surgery
            name === CTA_IDS.transfer &&
            (currentOrderType === 'ZLC' || currentOrderType === 'ZLB') &&
            process.env.ENABLE_SCHEDULE_SURGERY
        ) {
            transferSurgery(myCaseRef);
        } else if (
            name === CTA_IDS.procedureData &&
            (currentOrderType === 'ZLC' ||
                currentOrderType === 'ZLB' ||
                currentOrderType === 'ZOR')
        ) {
            dispatch(
                setReportProcedureModalState({
                    showReportProcedureModal: true,
                })
            );
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef: myCaseRef,
                    orderSummaryModal: false,
                })
            );
        } else if (
            name === CTA_IDS.shippingTracking &&
            (rowData?.currentOrderType === 'ZOR' ||
                rowData?.currentOrderType === 'KB')
        ) {
            dispatch(
                setOrderSummaryTabAction({
                    selectedTabId: OrderSummaryTabs()[3].id,
                })
            );
            // if (isSearchOrderList) {
            //     dispatch(
            //         showHideSearchModalAction({
            //             showSearchModal: false,
            //         })
            //     );
            // }
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef: rowData.myCaseRef,
                    orderSummaryModal: orderSummaryModal,
                })
            );
        }else if(name === CTA_IDS.assignCredit) {
            onAssignTerritory(rowData.myCaseRef);
        } else {
            window.location.href = getWCMSRedirectionLink(
                {
                    myCaseRef: myCaseRef,
                    currentOrderType: currentOrderType,
                    accountNumber: accountNumber,
                },
                { ctaId: name }
            );
        }
        if (name === CTA_IDS.reportUsage || name === CTA_IDS.reportPayment) {
            const SURGERYVALIDATEACCOUNT = {
                orderType: 'ZLC',
                sapPartnerId: accountNumber.toString().padStart(10, '0'),
            };
            dispatch(getValidateAccountDetails(SURGERYVALIDATEACCOUNT));
            orderStatus = await getOrderStatusDetailsFunc(
                rowData?.myCaseRef || myCaseRef
            );
        }
    };

    const clickAwayHandler = () => {
        if (moreActionAnchorEl && moreActionAnchorEl.contains(event.target)) {
            return; // Don't close if clicking the anchor
        }
        setMoreActionOpen(false);
    };

    const closeOrderLockedPopup = () => {
        setShowOrderLockedPopup({
            show: false,
            myCaseRef: null,
            modifiedBy: null,
        });
    };

    const closeQrCodePopup = (requestParams) => {
         try {
            const myCaseRef = requestParams?.myCaseRef;
                setShowTorqueQR(false);
                if(myCaseRef && !qrGenerated[myCaseRef]) {
                        dispatch(setQrGenerated({ [myCaseRef]: true }));
                    }
                } catch (error) {
                    logErrorToConsole(error);
                }
    };

    return (
        <>
            {!isAllowed && statusCode === '13202' && (
                <MessageTemplate
                    isDeliveryCheck={true}
                    onClose={() => {
                        try {
                        handleCloseDeliveryCheckPopUp('edit');
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    content={
                        'edit'
                    }
                    width={'100%'}
                    marginB={'25px'}
                    position={'static'}
                    height={'auto'}
                    title={
                        t('orders.deliveryCheck.editTitle')
                    }
                    fontWeight={'800'}
                />
            )}
            {!isAllowed && statusCode === '13203' && isFutureDatedOrder && (
                <MessageTemplate
                 id="orders-orderdetailfooter-delivery-check-no-usage-popup"
                            isDeliveryCheck={true}
                            onClose={() => {
                                try {
                        handleCloseDeliveryCheckPopUp();
                                } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                            content={
                                'noUsageToReport'
                            }   
                            width={'100%'}
                            marginB={'25px'}
                            position={'static'}
                            height={'auto'}
                            title={
                                t('orders.deliveryCheck.noUsageTitle')
                            }
                            fontWeight={'800'}
                    />
                
            )}
            {isAllowed && statusCode === '13201' && isFutureDatedOrder && (
                <MessageTemplate
                 id="orders-orderdetailfooter-delivery-check-cancel-confirmation-popup"
                            isDeliveryCheck={false}
                            onClose={() => {
                                try {
                        handleCloseDeliveryCheckPopUp();
                                } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                            content={
                                t('orders.deliveryCheck.confirmOrderCancellation')
                            }   
                            width={'100%'}
                            marginB={'25px'}
                            position={'static'}
                            height={'auto'}
                            title={
                                t('orders.deliveryCheck.cancelTitle')
                            }
                            fontWeight={'800'}
                            myCaseRef={orderList?.[0]?.myCaseRef || ''}
                            handleNoReportUsageCancellation={handleNoReportUsageCancellation}
                    />
                
            )}
            <OrderDetailFooterBottomNavWrapper>
                {orderBasicDetails?.currentOrderType != 'KE' &&
                        (orderBasicDetails?.currentOrderType != 'KB' ||
                            isOrderHistoryContext ||
                            orderListCallActions.length > 0) &&
                        orderBasicDetails?.currentOrderType != 'ZKA' ? (
                <BottomNavigation
                    className={'Bottom-footer'}
                    justifyContent={'flex-end'}
                    opacity={'1'}
                    position={'absolute'}
                    mbPosition={'fixed'}
                    buttonsPosition={'fixed'}
                    padding={
                        window.innerWidth <= sizes.mobileDevice ? '11px' : '5px'
                    }
                    mbPadding={'11px'}
                    mobileJustifyContent={'space-evenly'}    
                    smallDeviceJustifyContent={'center'}
                    isIPadPotrait={true}
                    iPadPortraitJustifyContent={'center'}
                    fromAccountPage={true}
                    isFromPhysicianDetails={isFromPhysicianDetails}
                >
                    {orderBasicDetails?.currentOrderType === 'ZOR' &&
                        primaryCTAObject?.ctaId &&
                        primaryCTAId !== 'CTA_001' &&
                        primaryCTAId !== 'CTA_014' &&
                        primaryCTAId !== 'CTA_015' &&
                        !isOrderHistory && (
                        <>
                            <Button
                                id={'orders-orderdetails-orderdetailsfooter-requestinvoicebutton'}
                                show
                                width={
                                    isLanguageChanged
                                        ? 'max-content'
                                        : isMobile
                                            ? '33%'
                                            : '21%'
                                }
                                minWidth={isMobile ? '33%' : '21%'}
                                mobileWidth={
                                    isLanguageChanged ? 'max-content' : '50%'
                                }
                                mobileMinWidth={'48%'}
                                height={'38px'}
                                clicked={(event) => {
                                    handleClick(event);
                                }}
                                // border={'1px solid #1010EB'}
                                // color={'#1010EB'}
                                margin={
                                    isMobile
                                        ? '2px 5px 2px 5px'
                                        : '4px 0px 4px 10px'
                                }
                                fontSize={'15px'}
                                borderRadius={'25px'}
                                //secondary
                                variant={ButtonStyles?.secondary}
                            >
                                {t('more.common.moreActions')}
                            </Button>
                            <Button
                                id={'orders-orderdetails-orderdetailsfooter-viewusagereportsbutton'}
                            
                                show
                                width={
                                    isLanguageChanged
                                        ? 'max-content'
                                        : isMobile
                                            ? '33%'
                                            : '21%'
                                }
                                minWidth={isMobile ? '33%' : '21%'}
                                mobileWidth={
                                    isLanguageChanged ? 'max-content' : '50%'
                                }
                                mobileMinWidth={'48%'}
                                height={'38px'}
                                clicked={() =>
                                    onMoreActionsSelectHandler(
                                        primaryCTAObject.ctaId,
                                        false,
                                        primaryCTAObject.ctaName
                                    )

                                }
                                margin={
                                    isMobile
                                        ? '2px 5px 2px 5px'
                                        : '4px 20px 4px 10px'
                                }
                                fontSize={'15px'}
                                borderRadius={'25px'}
                                    //primary
                                variant={ButtonStyles?.primary}
                            >
                                {primaryCTAObject.ctaName ===
                                    t('orders.orderStatuses.viewUsageReports')
                                    ? t('orders.shipTrackLabels.usagereport')
                                    : primaryCTAObject.ctaName}
                            </Button>
                        </>
                    )}

                    {!(
                        orderBasicDetails?.currentOrderType === 'ZOR' &&
                        primaryCTAObject?.ctaId &&
                        primaryCTAId !== 'CTA_001' &&
                        primaryCTAId !== 'CTA_014' &&
                        primaryCTAId !== 'CTA_015' &&
                        !isOrderHistory
                    ) &&
                        orderBasicDetails?.currentOrderType != 'KE' &&
                        orderBasicDetails?.currentOrderType != 'ZKA' && (
                        <Button
                                // color is send seperatly
                            id={'orders-orderdetails-orderdetailsfooter-moreactionsbutton'}

                            show={orderListCallActions.length > 0}
                            width={
                                isLanguageChanged
                                    ? 'max-content'
                                    : isMobile
                                        ? '33%'
                                        : '21%'
                            }
                            minWidth={isMobile ? '33%' : '21%'}
                            mobileWidth={
                                isLanguageChanged ? 'max-content' : '45%'
                            }
                            mobileMinWidth={'45%'}
                            height={'38px'}
                            clicked={(event) => {
                                handleClick(event);
                            }}
                            border={'1px solid #1010EB'}
                            color={'#1010EB'}
                                margin={
                                    isMobile
                                        ? '2px'
                                        : '4px 20px 4px 10px'
                                }
                            fontSize={'15px'}
                            borderRadius={'25px'}
                                //secondary
                            variant={ButtonStyles?.secondary}
                        >
                            {t('more.common.moreActions')}
                        </Button>
                    )}

                        {/* {orderBasicDetails.currentOrderType === 'KE' ? (
                    <Button
                        show
                        width={isMobile ? '37%' : '20%'}
                        mobileWidth={'45%'}
                        height={'38px'}
                        clicked={(event) => {
                            handleClick(event);
                        }}
                        border={'1px solid #140F4B '}
                        margin={
                            isMobile ? '2px 0px 2px 0px' : '4px 20px 4px 10px'
                        }
                        fontSize={'15px'}
                        borderRadius={'25px'}
                        primary={true}
                        background-color={'#1010EB'}
                    >
                        Primary CTA
                    </Button>
                ) : (
                    ''
                )} */}
                    {showReportUsageBlockPopUp &&
                        validateAccount?.data?.blockMessage ? (
                        <MessageTemplate
                            isDeliveryCheck={true}
                            onClose={() => {
                                    try {
                                dispatch(resetValidateAccountDetails());
                                setShowReportUsageBlockPopUp(false);
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                            }}
                            content={validateAccount?.data?.blockMessage}
                            width={'100%'}
                            marginB={'32px'}
                            position={'static'}
                            height={'auto'}
                            title={t(
                                'ConsignmentAdd.surgery.notifications.accountBlocked'
                            )}
                            fontWeight={'800'}
                            blocked
                            background={'None'}
                        />
                    ) : null}
                    {orderBasicDetails?.currentOrderType !== 'ZOR' &&
                        primaryCTAObject?.ctaId &&
                        primaryCTAId !== 'CTA_001' &&
                        primaryCTAId !== 'CTA_014' &&
                        !(isSurgeryOrder && isOrderHistoryContext) ? (
                        <Button
                         id={'orders-orderdetails-orderdetailsfooter-usagereportbutton'}
                            
                            show
                            width={
                                isLanguageChanged
                                    ? 'max-content'
                                    : orderBasicDetails?.currentOrderType ===
                                        'ZKA'
                                        ? '260px'
                                        : isMobile
                                            ? '33%'
                                            : '23%'
                            }
                            minWidth={
                                orderBasicDetails?.currentOrderType === 'ZKA'
                                    ? '260px'
                                    : isMobile
                                        ? '33%'
                                        : '23%'
                            }
                            mobileWidth={
                                isLanguageChanged ? 'max-content' : '45%'
                            }
                            mobileMinWidth={'45%'}
                            height={'38px'}
                            clicked={
                                orderBasicDetails?.currentOrderType === 'ZKA'
                                    ? () => { 
                                    }
                                    : () =>
                                        onMoreActionsSelectHandler(
                                            primaryCTAObject.ctaId,
                                            false,
                                            primaryCTAObject.ctaName
                                        )
                            }
                            margin={
                                isMobile
                                    ? '2px'
                                    : '4px 0px 4px 10px'
                            }
                            fontSize={'15px'}
                            borderRadius={'25px'}
                            //primary
                            variant={ButtonStyles?.primary}
                        >
                            {primaryCTAObject.ctaName ===
                                t('orders.orderStatuses.viewUsageReports')
                                ? t('orders.shipTrackLabels.usagereport')
                                : primaryCTAObject.ctaName}
                        </Button>
                    ) : null}
                    <Popper
                        className={classes.root}
                        open={moreActionOpen}
                        anchorEl={moreActionAnchorEl}
                        placement={'top'}
                    >
                        <ClickAwayListener onClickAway={clickAwayHandler}>
                            <Paper className={classes.papper}>
                                        {/* <MobileView> */}
                                        {orderListCallActions?.length > 0 ? (
                                            <>
                                                {orderListCallActions
                                                    ?.filter((data, index) => {
                                                        return (
                                                            index ===
                                                            orderListCallActions.findIndex(
                                                                (d) =>
                                                                    data.ctaId ===
                                                                    d.ctaId
                                                            )
                                                        );
                                                    })
                                                    ?.map((actions) => {
                                                        return (
                                                            <React.Fragment
                                                                key={
                                                                    actions.ctaId
                                                                }
                                                            >
                                                                <Typography
                                                                  id={`orders-orderdetailfooter-more-actions-option-${actions.ctaId}`}
                                                                    onClick={() => {
                                                                            try {
                                                                        onMoreActionsSelectHandler(
                                                                            actions.ctaId,
                                                                            true,
                                                                            actions.ctaName
                                                                        );
                                                                            } catch (error) {
                                                                                  logErrorToConsole(error);
                                                                             }
                                                                    }}
                                                                    className={
                                                                        classes.typography
                                                                    }
                                                                >
                                                                    <MdiOptions
                                                                        imageSrc={actions.ctaId === CTA_IDS.addReportUsage
                                                                            ? undefined
                                                                            : MdiImageSource(actions.ctaId)}
                                                                    //As we are getting CallToAction from order summary API, there is no need of segregation between calendar and order CTA names.
                                                                    >
                                                                        {actions.ctaId === CTA_IDS.addReportUsage && (
                                                                            <PostAddIcon style={{ width: 18, height: 18, color: '#1010EB' }} />
                                                                        )}
                                                                    </MdiOptions>{' '}
                                                                    {actions.ctaName ===
                                                                        t(
                                                                            'orders.orderStatuses.viewUsageReports'
                                                                        )
                                                                        ? t(
                                                                            'orders.shipTrackLabels.usagereport'
                                                                        )
                                                                        : actions.ctaName}
                                                                </Typography>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                            </>
                                        ) : null}
                                    </Paper>
                        </ClickAwayListener>
                    </Popper>
                </BottomNavigation>)
                : null
                }
            </OrderDetailFooterBottomNavWrapper>
            {showOrderLockedPopup.show && (
                <CancelAlertPopup
                    popupTitle={t('orders.shipTrackLabels.lockededit')}
                    alertMessage={`${t('orders.shipTrackLabels.mycaseorder')} ${showOrderLockedPopup.myCaseRef
                        } ${t('orders.shipTrackLabels.msg')} ${showOrderLockedPopup.modifiedBy
                        }.`}
                    btn1Label={t(
                        'orders.orderDetails.orderDetailFooter.cancel'
                    )}
                    cancelBtn
                    btnCloseClickHandler={closeOrderLockedPopup}
                    btn1ClickHandler={closeOrderLockedPopup}
                />
            )}
             {retriggerEventNotification==='fromSummary'&&(<UnsavedChanges isFromSummary={true} isFromOrderListingPage={true}
                onDiscard={() => handleEventRetrigger( myCaseRef, currentOrderType)}
                    onClose={() =>{
                        setRetriggerEventNotification(false);
                        setNotificationDetails({});}
                    
                    }
                    />)}
            {deleteNotAllowedPopupOpen && (
                <UnidHubOrderDeletePopup
                id="orders-orderdetailfooter-unid-hub-order-delete-popup"
                    onClose={() => {
                        try {
                        setDeleteNotAllowedPopupOpen((prev) => !prev);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />
            )}
            {showTorqueQR && (
                <>
                    {ReactDOM.createPortal(
                        <TorqueQROverlay />,
                        document.body
                    )}
                    <ModalDialog
                        handleClose={() => closeQrCodePopup(torqueQRParams)}
                        modalHeight={'396px'}
                        maxWidth={'450px'}
                        padding={'1px'}
                        isMobileDevice={true}
                        zIndex={2100}
                        crossMarginTop={'15px'}
                        borderTopLeftRadius={isMobileDevice && '1px' }
                        borderTopRightRadius={isMobileDevice && '1px' }
                        mobilePaperFullScreenHeight={isMobileDevice &&'50%'}
                        marginTop={isMobileDevice && '1px'}
                        isFromQRCodePopup={isMobileDevice && true}
                    >
                        <TorqueQRCode
                            requestParams={torqueQRParams}
                            qrCodeData={qrCodeData}
                            qrCodeLoading={qrCodeLoading}
                            qrCodeError={qrCodeError}
                            setShowTorqueQR={setShowTorqueQR}
                            qrGenerated={qrGenerated}
                            onClose={() => closeQrCodePopup(torqueQRParams)}
                        />
                    </ModalDialog>
                </>
            )}

        </>
    );
};

export default OrderDetailFooter;
